import { Typography, Tooltip } from "@material-ui/core";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import { get } from "lodash";
import React from "react";
import { useStyles } from "./styles";

const ProfileView = ({ parentComment }) => {
  const classes = useStyles();
  return (
    <div className={classes.userName}>
      <UserProfileWidget
        firstName={get(parentComment, "createdBy.firstName", "")}
        lastName={get(parentComment, "createdBy.lastName", "")}
        url={get(parentComment, "createdBy.profileImage.fileName", "")}
      />
      <Tooltip title={get(parentComment, "createdBy.firstName", "")}>
        <Typography
          variant="subtitle2"
          className="f-light-gray font-regular font-12"
          noWrap="true">
          {get(parentComment, "createdBy.firstName", "")}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default ProfileView;
